import React from 'react';
import { FullTable, AddCircleBlue } from 'components';
import { sortListByKey, useModal } from 'utils';
import { PAYCODE_ACTION, paycodeBody, paycodeHead } from './constants';
import { PayCodeType } from './modals';
import { useSelector } from 'react-redux';

export const PaycodeTypesList = ({ }) => {
    const { open } = useModal();
    const globalPayCodes = useSelector((state) => state.payroll.payCodes);

    return (
        <div>
            <div className="header-action-btn" style={{marginTop: '-24px'}}>
                <AddCircleBlue text="Add Paycode Type" handleClick={() => open(<PayCodeType />)} />
            </div>
            <FullTable
                head={paycodeHead}
                body={paycodeBody}
                loadingType={PAYCODE_ACTION}
                list={globalPayCodes?.length ? sortListByKey(globalPayCodes, 'name') : []}
                noText={'paycodes'}
                handleClickButton={(i) => open(<PayCodeType info={i} />)}
                margin={'16px 0 0 0'}
            />
        </div>
    );
};
